module.exports = __webpack_public_path__ + "static/media/icon_zoom.2130d50b.svg";